import LoadingBanner from 'components/banners/LoadingBanner';
import PublicRoutes from 'navigation/PublicRoutes';
import React from 'react';
import ReactDom from 'react-dom';
import Loadable from 'react-loadable';
import { HashRouter } from 'react-router-dom';
import store from 'store';
import 'styles/styles.scss';
import 'react-datepicker/dist/react-datepicker.css';

const LoginApp = () => (
  <HashRouter>
    <PublicRoutes/>
  </HashRouter>
);

const UIApp = Loadable({
  loader: () => import('./main'),
  loading: LoadingBanner
});

class App extends React.Component {
  render() {
    return store.get('token') ? <UIApp/> : <LoginApp/>;
  }
}

ReactDom.render(
  <App/>,
  document.getElementById('root')
);
